import React from 'react';
import { BUILD_INFO } from '../../buildInfo';

/**
 * Footer minimaliste responsive avec date, heure, version et référence commit
 * Utilise les infos générées automatiquement à chaque build
 */
const Footer = () => {
  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-[#0B0C10]/80 backdrop-blur-sm border-t border-white/5 z-40 safe-bottom">
      {/* Version mobile - simplifiée */}
      <div className="lg:hidden h-8 flex items-center justify-center px-3">
        <div className="flex items-center gap-2 text-[9px] text-white/30 font-mono">
          <span className="text-[#66FCF1]/50 font-semibold">{BUILD_INFO.version}</span>
          <span className="text-white/10">•</span>
          <span className="truncate">
            <a
              href="https://coachdigitalparis.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#b19873] hover:text-[#d4b896] transition-colors"
            >
              G. KORZEC
            </a>
          </span>
        </div>
      </div>

      {/* Version desktop - complète */}
      <div className="hidden lg:flex h-6 items-center justify-center gap-4 text-[10px] text-white/30 font-mono">
        <span className="text-[#66FCF1]/50 font-semibold">{BUILD_INFO.version}</span>
        <span className="text-white/10">•</span>
        <span>{BUILD_INFO.date}</span>
        <span className="text-white/10">•</span>
        <span>{BUILD_INFO.time}</span>
        <span className="text-white/10">•</span>
        <span className="text-[#66FCF1]/40">{BUILD_INFO.commitShort}</span>
        <span className="text-white/10">•</span>
        <span className="uppercase">
          Créé et diffusé par{' '}
          <a
            href="https://coachdigitalparis.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#b19873] hover:text-[#d4b896] transition-colors underline"
          >
            M. KORZEC
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
